export default "__VITE_ASSET__DX2h7uFo__"